export default __webpack_public_path__ + "static/media/chef de département.528f8941.mp4";